/* Types */
import { Mode } from '@/types/main'

/**
 * Проверка окружения приложения на [DEVELOPMENT, BRANCH]
 * @param moduleName - наименование модуля
 * @param mode - окружение приложения
 */
export const checkDevAndBranchOfEnv = (moduleName: string, mode: string) => {
  if ([Mode.DEVELOPMENT].includes(mode as Mode)) {
    console.warn(`${moduleName} disabled for ${mode} mode`)

    return true
  }

  return false
}
